var nanvdb = window.nanvdb || {};

nanvdb.map = {
	form: null,
	markers: [],
	useSpiderfier: true,
	oms:null,
	init: function() {
		if (moya.map.osmMap) {
			if (nanvdb.map.useSpiderfier) {
				nanvdb.map.initSpiderfier();
			}
			nanvdb.map.fetchMarkers();
			this.form = $('#nanvdbSearch');
			this.bindEvents();
		}
	},

	initSpiderfier: function() {
		nanvdb.map.oms = new OverlappingMarkerSpiderfier(moya.map.osmMap, {
			markersWontMove: true,
			markersWontHide: true,
			keepSpiderfied: true
		});

		nanvdb.map.oms.addListener('format', function(marker, status) {
			var iconPath = '/static/themes/2020/images/';
			var icon = status === OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED ? 'map_pin.png' :
				status === OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE ? 'map_pin_plus.png' :
				status === OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE ? 'map_pin.png' :
				null;

			if (icon) {
				marker.setIcon({
					url: iconPath + icon,
					scaledSize: new osmMap.maps.Size(17, 26)
				});
			}
		});

	},

	bindEvents: function() {
		this.form.find('select').on('change', nanvdb.map.submitForm);
		this.form.find('input').on('change', nanvdb.map.submitForm);

		this.form.find('input[type="checkbox"]').on('change', function(event) {
			if ($(event.target).is(':checked')) {
				$(event.target).parent('label').addClass('active');
			}
			else {
				$(event.target).parent('label').removeClass('active');
			}
		});

		this.form.find('#category').on('change', function() {
			$('#nanvdbSearch').find('.elm', '#fieldset-activitiesDG').removeClass('show');
			$('#nanvdbSearch').find('input:checkbox', '#fieldset-activitiesDG').prop('checked', false);
			$('#nanvdbSearch').find('label', '#fieldset-activitiesDG').removeClass('active');

			var $this = $(this),
				$parent = $('#nanvdbSearch').find('input[rel="'+$this.val()+'"]').parents('.elm');

			if ($parent.length) {
				$('#elm_category').addClass('active');
			}
			else {
				$('#elm_category').removeClass('active');
			}

			$parent.addClass('show');
		});

		this.form.on('submit', function(e) {
			e.preventDefault();
			nanvdb.map.submitForm();
		})
	},
	resetAllMarkers: function() {
		for (i = 0; i < nanvdb.map.markers.length; i++) {
			var marker = nanvdb.map.markers[i];
			marker.setVisible(true);
		}
	},
	submitForm: function() {
		var category = $(this.form).find('#category').val(),
			city = $(this.form).find('#city').val(),
			query = $(this.form).find('#query').val(),
			$activities = $(this.form).find('input:checkbox:checked', '#fieldset-activitiesDG');

		var activities = [];
		$.each($activities, function(index, element) {
			activities.push($(element).val());
		});

		if (nanvdb.map.useSpiderfier) {
			nanvdb.map.oms.clearMarkers();
		}

		var newmarkers = [];
		for (i = 0; i < nanvdb.map.markers.length; i++) {
			var visible = true;
			var marker = nanvdb.map.markers[i];

			if (category && category.length > 1 && marker.properties['category'] !== category) {
				visible = false;
			}
			if (city && city.length > 1 && marker.properties['city'] !== city) {
				visible = false;
			}
			if (query && query.length > 0) {
				if (marker.properties['title'].indexOf(query) === -1) {
					visible = false;
				}
			}

			if (activities.length && $.inArray(marker.properties['activity'], activities) === -1) {
				visible = false;
			}

			if (!visible) {
				marker._icon.style.display = 'none'
				marker._shadow.style.display = 'none'
			}
			else {
				marker._icon.style.display = ''
				marker._shadow.style.display = ''
				newmarkers.push(marker);
				nanvdb.map.oms.addMarker(marker);
			}
		}
		if (nanvdb.map.useSpiderfier) {
			//Force icon change
			nanvdb.map.oms.map.setZoom(nanvdb.map.oms.zoom);
		}
	},
	fetchMarkers: function() {
		$.ajax({
			method: 'get',
			url: 'https://www.ssne.is/_/moya/nanvdb/ajax/markers',
			data: $(this.form).serializeArray()
		}).done(function(r) {
			if (r) {
				var popup = new L.Popup();

				$.each(r, function(key, value) {
					var latLng = L.latLng(value['position']['lat'], value['position']['lng']);
					var marker = new L.marker(latLng);

					var markerInfo =
						'<div class="marker__info">' +
							'<div class="info__title">'+value['title']+'</div>';

					if (value['activity']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Tegund:</span>' +
							'<span class="details__value">'+value['activity']+'</span>' +
							'</div>';
					}
					if (value['location']['address']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Heimilisfang:</span>' +
							'<span class="details__value">'+value['location']['address']+', '+value['location']['zip']+ ' '+value['location']['city']+'</span>' +
							'</div>';
					}
					if (value['contact']['phone']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Símanúmer:</span>' +
							'<span class="details__value">'+value['contact']['phone']+'</span>' +
							'</div>';
					}
					if (value['contact']['name']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Tengiliður:</span>' +
							'<span class="details__value">'+value['contact']['name']+'</span>' +
							'</div>';
					}
					if (value['contact']['email']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Netfang:</span>' +
							'<span class="details__value"><a href="mailto:'+value['contact']['email']+'">'+value['contact']['email']+'</a></span>' +
							'</div>';
					}
					if (value['contact']['website']) {
						markerInfo +=
							'<div class="details">' +
							'<span class="details__label">Heimasíða:</span>' +
							'<span class="details__value"><a href="' + value['website'] + '" target="_blank">' + value['website'] + '</a></span>' +
							'</div>';
					}

					marker.properties = {
						category: value['category'],
						city: value.location['city'],
						title: value['title'],
						activity: value['activity'],
					}

					markerInfo += '</div>';
					marker.desc = markerInfo;
					nanvdb.map.oms.addListener('click', function(marker) {
						popup.setContent(marker.desc);
						popup.setLatLng(marker.getLatLng());
						moya.map.osmMap.openPopup(popup);
					});

					moya.map.osmMap.addLayer(marker)


					if (nanvdb.map.useSpiderfier) {
						nanvdb.map.oms.addMarker(marker);
					}
					nanvdb.map.markers.push(marker);
				});
			}
		}).error(function() {
			alert('error');
		});
	}
};

nanvdb.search = {
	form: null,
	render: null,
	init:function() {
		this.form = $('#nanvdbSearch');
		this.render = this.form.find('#render').val();
		this.bindEvents();
	},
	bindEvents: function() {
		this.form.find('select').on('change', nanvdb.search.submitForm);
		this.form.find('input').on('change', nanvdb.search.submitForm);

		this.form.find('input[type="checkbox"]').on('change', function(event) {
			if ($(event.target).is(':checked')) {
				$(event.target).parent('label').addClass('active');
			}
			else {
				$(event.target).parent('label').removeClass('active');
			}
		});

		this.form.find('#category').on('change', function() {
			$('#nanvdbSearch').find('.elm', '#fieldset-activitiesDG').removeClass('show');
			$('#nanvdbSearch').find('input:checkbox', '#fieldset-activitiesDG').prop('checked', false);
			$('#nanvdbSearch').find('label', '#fieldset-activitiesDG').removeClass('active');

			var $this = $(this),
				$parent = $('#nanvdbSearch').find('input[rel="'+$this.val()+'"]').parents('.elm');

			if ($parent.length) {
				$('#elm_category').addClass('active');
			}
			else {
				$('#elm_category').removeClass('active');
			}

			$parent.addClass('show');
		});

		// Uncheck all activity checkboxes
		$('#nanvdbSearch').find('input:checkbox', '#fieldset-activitiesDG').prop('checked', false);
		nanvdb.search.submitForm();

		this.form.on('submit', function(e) {
			e.preventDefault();
			nanvdb.search.submitForm();
		})
	},
	submitForm: function() {
		$.ajax({
			method: 'get',
			url: 'https://www.ssne.is/_/moya/nanvdb/ajax/search',
			data: $(this.form).serializeArray()
		}).done(function(r) {
			if (r) {
				var content = '';
				for (var i = 0, iMax = r.length; i < iMax; i++) {
					content += nanvdb.search.renderCard(r[i]);
				}
				$('#nanvdbResults').html(content);
			}
		}).error(function() {
			alert('error');
		});
	},
	renderCard: function(data) {
		return '<div class="card">' +
			'<div class="card__title">'+data.title+'</div>' +
			'<div class="card__details">' +
				'<div class="details">' +
					'<span class="details__label">Tegund:</span>' +
					'<span class="details__value">'+data.activity+'</span>' +
				'</div>' +
				'<div class="details">' +
					'<span class="details__label">Heimilisfang:</span>' +
					'<span class="details__value">'+data.address+', '+data.zip+ ' '+data.city+'</span>' +
				'</div>' +
				'<div class="details">' +
					'<span class="details__label">Símanúmer:</span>' +
					'<span class="details__value">'+data.contactPhone+'</span>' +
				'</div>' +
				'<div class="details">' +
					'<span class="details__label">Tengiliður:</span>' +
					'<span class="details__value">'+data.contactName+'</span>' +
				'</div>' +
				'<div class="details">' +
					'<span class="details__label">Netfang:</span>' +
					'<span class="details__value"><a href="mailto:'+data.contactEmail+'">'+data.contactEmail+'</a></span>' +
				'</div>' +
				'<div class="details">' +
					'<span class="details__label">Heimasíða:</span>' +
					'<span class="details__value"><a href="'+data.website+'" target="_blank">'+data.website+'</a></span>' +
				'</div>' +
			'</div>' +
		'</div>';
	}
};

nanvdb.admin = {
	init: function() {
		this.initAutocomplete();
	},
	initAutocomplete: function() {
		$('input#category', '#nanvdb').autocomplete({
			source: '/_/moya/nanvdb/ajax/autocompleteCategory'
		});
		$('input#activity', '#nanvdb').autocomplete({
			source: '/_/moya/nanvdb/ajax/autocompleteActivity'
		});
	}
};